import cn from 'classnames';
import type { FC } from 'react';
import React from 'react';

import type { TTab } from './models';

/* Данный компонент используется для семантики в клиентском коде. */
export const Tab: FC<React.PropsWithChildren<TTab>> = ({
    children,
    className,
    dataTestId,
    hidden = false,
    id,
    styles,
}) => {
    const stringId = String(id);

    return (
        <div
            className={cn(className, { [styles.hidden]: hidden })}
            data-test-id={dataTestId ?? stringId}
            id={stringId}
        >
            {children}
        </div>
    );
};
